import { render, staticRenderFns } from "./ActiveStatusForm.vue?vue&type=template&id=745a2b88"
import script from "./ActiveStatusForm.vue?vue&type=script&lang=js"
export * from "./ActiveStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports